export default __webpack_public_path__ + "static/media/reward-1.8eaace4e.png";